import { takeLatest, put, call, SagaReturnType } from 'redux-saga/effects';
import { departmentDashboard } from '../../actions/constant';
import departmentDashboardService from '../../../services/departmentDashboard/getDepartmentDashboardCount';

const {
  GET_ALL_PHYSICIANS_REQUEST,
  GET_ALL_PHYSICIANS_SUCCESS,
  GET_ALL_PHYSICIANS_FAILURE,
  GET_ALL_PHYSICIANS_LOADING,
} = departmentDashboard;

function* getAllPhysicians(action: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_ALL_PHYSICIANS_LOADING });
    const response = yield call(departmentDashboardService.getAllPhysicians, action.payload);
    if (response?.status === 200) {
      yield put({ type: GET_ALL_PHYSICIANS_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_ALL_PHYSICIANS_FAILURE, payload: error });
  }
}

function* getAllPhysiciansSaga() {
  yield takeLatest(GET_ALL_PHYSICIANS_REQUEST, getAllPhysicians);
}

export default getAllPhysiciansSaga;
